import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

import { Dosage } from './dosage.types';

type DosageTextViewProps = {
   readonly dosage: Dosage;
};

export const DosageTextView = (props: DosageTextViewProps): JSX.Element => {
   return (
      <StyledPrescriptionTextView testId={'dosage'} compact label={prescriptionTranslationKeys.dosage.DS}>
         {props.dosage ?? '-'}
      </StyledPrescriptionTextView>
   );
};
